import angular from "angular";
import notify from "@cgross/angular-notify";
import angularMoment from "angular-moment";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";

let m = angular
    .module('activeOperations.component', [notify, angularMoment, angularUIB, core])
    .component('activeOperations', {
        template: require('./active-operations.component.html'),
        controller: [
            '$interval',
            '$rootScope',
            '$timeout',
            '$http',
            '$q',
            'notify',
            'moment',
            '$uibModal',
            'Auth',
            'notifier',
            controller
        ],
        bindings: {
            balance: '@',
            operations: '<',
            transactions: '<',
            carTypes: '<',
            articles: '<',
            doAlertNotification: '<',
            activeUsers: '<'
        }
    });

function controller($interval, $rootScope, $timeout, $http, $q, notify, moment, $uibModal, Auth, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.mode = 'line';

        $ctrl.changeTypes = {
            'book': 'Новая заявка!',
            'send-to-confirm': 'Отпр. на оформление',
            'confirm-success': 'Успешно оформилась',
            'confirm-fail': 'Ошибка при оформлении',
            'cancel': 'Отменен',
            'auto-cancel': 'Авт. отменен',
            'send-to-refund': 'Отпр. на возврат',
            'refund-success': 'Успешно возвращен',
            'refund-reject': 'Возврат отвергнут',
            'refund-error': 'Ошибка при возвратe',
        };

        $ctrl.transactionTypes = {
            correcting: 'Корректировка остатка',
            'refill-non-based': 'Пополн. без основания',
            'refill-based': 'Пополн. на основании',
            'inverse-refill-based': 'Списание на счет субаг.',
            'inverse-refill-non-based': 'Списание на счет субаг.',
            'inverse-correcting': 'Корректировка остатка субаг.',
            'book-order': 'Бронирование заявки',
            'cancel-order': 'Отмена заявки',
            'refund-ticket': 'Возврат билета',
        };

        $timeout(function () {
            refreshOperations();
        });

        if ($ctrl.doAlertNotification) {
            $timeout(function () {
                $ctrl.doAlertNotification = false;
            }, 3000)
        }

    };

    $ctrl.toggleMode = function () {
        $ctrl.mode = $ctrl.mode == 'line' ? 'table' : 'line';
    };

    function refreshOperations() {
        for (let i = 0; i < $ctrl.operations.length; i++) {
            refreshOperationData($ctrl.operations[i]);
        }
    }

    function refreshOperationData(operation) {
        operation.showAll = false;
        operation.status = getStatus(operation);
        operation.routeText = getRouteText(operation);
        operation.passengersText = getPassengersText(operation);
        operation.ticketsList = operation.ticket ? [operation.ticket] : operation.order.tickets;
        if (operation.order.confirm_countdown) {
            setConfirmCountdownInterval(operation);
        }
    }

    function getStatus(operation) {

        let type = operation.type;

        if (type == 'confirm-success' || type == 'refund-success') {
            return 'success';
        }

        if (type == 'book' || type == 'send-to-confirm' || type == 'send-to-refund') {
            return 'info';
        }

        if (type == 'auto-cancel' || type == 'cancel') {
            return 'warning';
        }

        return 'danger';
    }

    function getRouteText(operation) {
        return operation.order.dep_station + ' - ' + operation.order.arr_station;
    }

    function getPassengersText(operation) {
        if (operation.ticket) {
            return '1 пасс: ' + operation.ticket.passenger.last_name + ' ' + operation.ticket.passenger.first_name[0] + '.';
        } else {
            let t = '';
            for (let i = 0; i < operation.order.tickets.length; i++) {
                let p = operation.order.tickets[i].passenger;
                t += p.last_name + ' ' + p.first_name[0] + '. ';
            }
            return operation.order.tickets.length + ' пасс: ' + t;
        }
    }

    function setConfirmCountdownInterval(operation) {
        operation.confirmInterval = $interval(function () {
            if (operation.order.confirm_countdown > 0) {
                operation.order.confirm_countdown--;
            } else {
                $interval.cancel(operation.confirmInterval);
            }
        }, 1000);
    }

    $ctrl.toggleShowAll = function (operation) {
        operation.showAll = !operation.showAll;
    };

    $rootScope.$on('order.changed', function (event, operation) {
        let ind = -1;
        for (let i = 0; i < $ctrl.operations.length; i++) {
            let cons = false;
            if (operation.ticket) {
                cons = $ctrl.operations[i].ticket &&
                    $ctrl.operations[i].order.id == operation.order.id &&
                    $ctrl.operations[i].ticket.number == operation.ticket.number;
            } else {
                cons = !$ctrl.operations[i].ticket && $ctrl.operations[i].order.id == operation.order.id;
            }
            if (cons) {
                ind = i;
                break;
            }
        }
        $timeout(function () {
            if (ind != -1) {
                $ctrl.operations.splice(ind, 1);
            }
            refreshOperationData(operation);
            if (!operation.isLocal) {
                notifyOperation(operation);
            }
            $ctrl.operations.unshift(operation);
        });
    });

    $ctrl.sendToConfirm = function (operation, ind) {
        if (operation.isConfirming) {
            return;
        }
        operation.isConfirming = true;
        $http
            .post('/railways-api/send-to-confirm', {
                orderId: operation.order.id
            })
            .then(
                function () {
                    operation.type = 'send-to-confirm';
                    operation.added_on = new Date();
                    operation.user = Auth.user;
                    operation.isConfirming = false;
                    operation.status = getStatus(operation);
                    $rootScope.$emit('activeOrders.sentToConfirm', {orderId: operation.order.id});
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                    operation.isConfirming = false;
                }
            )
    };

    $ctrl.cancelOrder = function (operation) {
        if (operation.isCanceling) {
            return;
        }
        operation.isCanceling = true;
        $http
            .post('/railways-api/cancel', {orderId: operation.order.id})
            .then(
                function () {
                    operation.isCanceling = false;
                    operation.order.status = 'canceled';
                    operation.type = 'cancel';
                    operation.added_on = new Date();
                    operation.user = Auth.user;
                    operation.status = getStatus(operation);
                    $rootScope.$emit('activeOrders.canceled', {orderId: operation.order.id});
                },
                function (error) {
                    operation.isCanceling = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.showErrorMessage = function (message) {
        notify({
            message: message,
            classes: 'alert alert-danger'
        });
    };

    function notifyOperation(operation) {
        notify.config({
            startTop: 72
        });
        notify({
            duration: 3000,
            templateUrl: '/templates/active-operation-notification.html',
            position: 'right',
            classes: operation.status,
            messageTemplate: getNotificationTemplate(operation),
        })
    }

    function getNotificationTemplate(operation) {
        let iconName = 'icon-';
        let viewBox = '0 0 ';
        if (operation.status == 'success') {
            iconName += 'success';
            viewBox += '16 16';
        }
        if (operation.status == 'danger') {
            iconName += 'abort';
            viewBox += '16 16';
        }
        if (operation.status == 'warning') {
            iconName += 'alert-circle';
            viewBox += '286 286';
        }
        if (operation.status == 'info') {
            iconName += 'process';
            viewBox += '399 399';
        }
        let number = operation.ticket ? operation.order.id + '/' + operation.ticket.number : operation.order.id;
        return `<div>
               <svg viewBox="${viewBox}" class="active-operation-notification__icon">
                    <use xlink:href="#${iconName}"></use>
                </svg>
                <div class="active-operation-notification__number">№${number}</div>
                <div class="active-operation-notification__text">${$ctrl.changeTypes[operation.type]}</div>
            </div>`;
    }



    $rootScope.$on('transaction.executed', function (event, data) {
        let afterBalance = data.type == 'payment' ? data.payment.after_balance : data.tickets[0].after_balance;
        $timeout(function () {
            $ctrl.transactions.unshift(data);
            $ctrl.balance = afterBalance;
            $ctrl.balanceActive = true;
            $timeout(function () {
                $ctrl.balanceActive = false;
            }, 3000);
        });
    });


    $rootScope.$on('article.published', function (event, data) {
        let article = data.article;
        $timeout(function () {
            $ctrl.articles.unshift(article);
        });
    });

    $rootScope.$on('article.opened', function (event, data) {
        let articleId = data.articleId;
        let ind = -1;
        for (let i = 0; i < $ctrl.articles.length; i++) {
            if ($ctrl.articles[i].id == articleId) {
                ind = i;
                break;
            }
        }
        if (ind != -1) {
            $timeout(function () {
                $ctrl.articles.splice(ind, 1);
            });
        }
    });

}

export default m.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/active-operations/active-operations.component.js